import * as amplitude from '@amplitude/analytics-browser';

import { AnalyticsEventName, AnalyticsEventProps } from './events';

/**
 * Единственная точка отправки продуктового события. Прямой `amplitude.track` в фичах не
 * пишем: имя события должно приходить из реестра `events.ts` (см. docstring там).
 *
 * Ключи со значением `undefined` отсекаются: Amplitude сохранил бы такое свойство пустым и
 * оно навсегда осталось бы в списке свойств события, засоряя фильтры в отчётах.
 */
export function trackEvent<N extends AnalyticsEventName>(name: N, props: AnalyticsEventProps[N]): void {
  amplitude.track(name, omitUndefined(props));
}

function omitUndefined(props: Record<string, unknown>): Record<string, unknown> {
  return Object.fromEntries(Object.entries(props).filter(([, value]) => value !== undefined));
}
